import type Collection from '@models/Collection'
import type { Author, TitleModelType } from '@models/Title'

export enum ScoreType {
  TEMPLATE = 'template',
  PUBLISHED = 'published',
  SELLING = 'selling',
  SHARED = 'shared',
  PRIVATE = 'private',
}

// Do not make this a class. Other objects like CollectionItem inherit from this and can be
// score-like. Instead of a class with functions, use the `score.util.ts` file to create helpers
export default interface Score {
  active_product_url: string | null
  active_title_url: string | null
  alias?: string
  archived?: boolean
  audio_preview_url?: string | null
  author?: Author
  collections?: Collection[]
  composer: string
  comments_count: number
  cover_art_directive: string | null
  cover_art_id: string | null
  cover_art_url: string | null
  currency?: string | null
  everyone_role?: string
  external_id: string
  favorites_count: number
  /** @deprecated */
  from_library?: string | null
  id: string
  is_content_library_copy: boolean
  is_product_copy: boolean
  is_soundcheck_score: boolean
  is_title_copy: boolean
  is_title_master: boolean
  title_type?: TitleModelType | null
  object_type: 'score'
  price?: number | null
  published_score_external_id?: string
  published_score_status?: string
  searchable: boolean
  template: boolean
  template_copies?: number
  title: string
  updated: number
  views_count: number
}

export enum PublishedStatus {
  FINALIZED = 'finalized',
  ARCHIVED = 'dam_archived',
  PUBLISHED = 'dam_published',
}

export const STATUS_MAP = {
  [PublishedStatus.FINALIZED]: 'Finalized',
  [PublishedStatus.ARCHIVED]: 'Archived',
  [PublishedStatus.PUBLISHED]: 'Published',
}
